<template>
  <div style="padding: 60px 20px 20px">
    <div class="commn">
      <div class="alert-box">
<!--        <Alert show-icon closable>注：每个学生只有一次答题机会。在答题规定时间内，如果遇到死机、关机、断网等中断答题的情况，再次打开习题即可继续作答，但是中断答题的时间仍记录在总时间内，不会顺时延长-->
<!--        </Alert>-->
      </div>
      <div class="start-box">
        <Details></Details>
        <hr/>
        <Button type="primary" @click="startAnswer" class="start-answer" v-show="!answerPage">开始答题</Button>
        <div class="exercises-list-box" v-show="answerPage">
          <ul>
            <li class="exercises-item open" v-for="(item,index) in question_banks_list" :key="index">
              <div class="exercises-item-title">
                <span class="exercises-item-title-name" v-show="item.question_type==1">{{index+1}}、单选题</span>
                <span class="exercises-item-title-name" v-show="item.question_type==2">{{index+1}}、多选题</span>
                <span class="exercises-item-title-name" v-show="item.question_type==3">{{index+1}}、判断题</span>
                <span class="exercises-item-title-name" v-show="item.question_type==4">{{index+1}}、解答题</span>
              </div>
              <div class="exercises-item-question">
                <div class="question-item" v-for="(it,idx) in item.question_list" :key="it.id">
                  <div v-if="item.question_type == 1 || item.question_type == 2 || item.question_type == 3">
                    <div class="question-content">
                      <div class="question-content-title">
                        <span class="question-content-title-name">{{idx+1}}、 {{it.content}}</span>
                        <span class="score-txt">{{it.score}}分</span>
                      </div>
                      <div class="question-answer" v-if="item.question_type == 1 || item.question_type == 3">
                        <RadioGroup v-model="it.answer" class="radio-group">
                          <Radio class="radio" v-for="(value, key, i) in it.option_object" :key="i" :label="key">
                            <em>{{key}}</em>
                            <span class="question-answer-details" >{{value}}</span>
                          </Radio>
                        </RadioGroup>
                      </div>
                      <div class="question-answer" v-else>
                        <CheckboxGroup v-model="it.answers" class="radio-group">
                          <Checkbox class="radio" v-for="(value, key, i) in it.option_object" :key="i" :label="key">
                            <em style="padding-left: 5px">{{key}}</em>
                            <span class="question-answer-details" >{{value}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.question_type == 4">
                    <div class="question-content">
                      <div class="question-content-title">
                        <span class="question-content-title-name">{{idx+1}}、 {{it.content}}</span>
                        <span class="score-txt">{{it.score}}分</span>
                      </div>
                      <div class="question-answer">
                        <Input v-model="it.answer" type="textarea" :rows="4" placeholder="请输入解题答案" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <Button type="primary" @click="submitAnswer" class="start-answer">提交试卷</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Details from './common/details'
  import {mapActions,mapState} from "vuex";

  export default {
    name: "start",
    data() {
      return {
        answerPage:false,
        question_banks_list:[]
      }
    },
    components: {
      Details
    },
    computed: {

    },
    methods: {
      ...mapActions({
        getQbCenterDetails: 'teachingScore/getQbCenterDetails',
        submitTestPaper:'teachingScore/submitTestPaper'
      }),
      startAnswer() {
        this.answerPage = true
      },
      submitAnswer(){
        let _this = this
        let param = {
          test_paper_id:_this.$route.params.qb_id,
          question_banks:[]
        }
        this.question_banks_list.forEach(item =>{
          item.question_list.forEach(it =>{
            param.question_banks.push({
              question_bank_id:it.id,
              answer:it.question_type == 2 ? it.answers.join(',') : it.answer
            })
          })
        })
        this.$Modal.confirm({
          title: '提交试卷',
          content: '<p>确定要提交试卷吗？提交后不可修改！</p>',
          onOk: () => {
            _this.submitTestPaper({
              data:param,
              callback:res =>{
                _this.$Message.success(res.status.message)
                _this.$router.push({
                  name: 'exerciseAnswer',
                  params: {qb_id: _this.$route.params.qb_id},
                })
              },
              err:res =>{
                _this.$Message.error(res.message)
              }
            })
          },
          onCancel: () => {}
        });
      }
    },
    mounted() {
      let _this = this
      this.getQbCenterDetails({
        id:_this.$route.params.qb_id,
        callback:res =>{
          let question_banks = []
          res.forEach(item =>{
            question_banks.push(JSON.parse(JSON.stringify(item)))
          })
          this.question_banks_list = question_banks
        }
      })
    },
  }
</script>

<style scoped lang="less">
  @import "../../assets/style/exercises";
  .commn {
    max-width: 1360px;
    margin-left: auto;
    margin-right: auto;

    .alert-box {
      margin: 20px 0;
    }

    .start-box {
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, .2);
      .start-answer{
        margin: 20px 0;
      }
    }
  }
</style>
